import { EmailRegister } from 'components/site/forms/Access/EmailRegister';
import { GoogleAccess } from 'components/site/forms/Access/GoogleAccess';
import { Message } from 'elements/minute/sidebar/sidebarComponents/atomic/Message';

import { OptionRowValue } from 'elements/minute/sidebar/sidebarComponents/atomic/OptionRowValue';
import { SidebarSubsectionHeader } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection/SidebarSubsectionHeader';
import { EBorders } from 'libs/styles/styling';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const RegisterForm = (props: Props): JSX.Element => {
    const navigate = useNavigate();
    const [sent, setSent] = useState<string>(null);

    return (
        <S_RegisterForm className={props.className}>
            <S_Center>
                <OptionRowValue
                    items={[{ text: Localization.LOGIN }, { text: Localization.REGISTRATION }]}
                    selectedIndex={1}
                    onSelected={(newIndex) => {
                        if (newIndex === 0) {
                            navigate('/login');
                        } else {
                            navigate('/register');
                        }
                    }}
                />
            </S_Center>
            <S_Line />
            {!sent && (
                <>
                    <S_SidebarSubsectionHeader
                        title={Localization.USING_SOCIALS}
                        icon={{
                            iconPrefix: 'fal',
                            iconName: 'share-nodes'
                        }}
                    />
                    <S_ExternalLoginButtons>
                        <S_GoogleAccess />
                    </S_ExternalLoginButtons>
                    <S_Line />
                    <S_SidebarSubsectionHeader
                        title={Localization.USING_MAIL}
                        icon={{
                            iconPrefix: 'fal',
                            iconName: 'envelope'
                        }}
                    />
                    <S_Mid>
                        <S_EMailRegister
                            onSent={(email) => {
                                setSent(email);
                            }}
                        />
                    </S_Mid>
                </>
            )}
            {sent && (
                <S_Wrap>
                    <Message type="info">
                        {Localization.VERIFICATION_SENT1}: <strong>{sent}</strong>.
                        <br /> {Localization.VERIFICATION_SENT2}
                    </Message>
                </S_Wrap>
            )}
        </S_RegisterForm>
    );
};

const S_RegisterForm = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 7px;
    border: 1px solid ${EBorders.DARK};
`;

const S_Center = styled.div`
    display: flex;
    justify-content: center;
    padding: 20px;
`;

const S_Line = styled.div`
    height: 1px;
    background-color: #d3d3d3;
    width: 100%;
`;

const S_SidebarSubsectionHeader = styled(SidebarSubsectionHeader)`
    margin: 5px 0;
`;

const S_ExternalLoginButtons = styled.div`
    display: flex;
    margin: 10px 20px 20px 20px;
    justify-content: center;
`;

const S_Mid = styled.div`
    display: flex;
    justify-content: center;
`;

const S_EMailRegister = styled(EmailRegister)`
    padding: 10px 0px 20px 0px;
    width: 250px;
`;

const S_GoogleAccess = styled(GoogleAccess)`
    margin: 0 0 0 10px;
`;

const S_Wrap = styled.div`
    padding: 20px;
    display: flex;
    justify-content: center;
`;
